import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "beneficios",
  class: "container-fluid custom-beneficios"
}
const _hoisted_2 = { class: "row justify-content-center py-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bold text-center mb-5 px-md-3 h3" }, " CONOCÉ LOS BENEFICIOS QUE TENEMOS PARA VOS ")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "col-md-10"
}
const _hoisted_5 = { class: "row justify-content-center g-4" }
const _hoisted_6 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_7 = { class: "row justify-content-center g-4" }

import { onMounted, ref } from 'vue'
import { Skeletor } from 'vue-skeletor'

import useSitio from '@/composables/useSitio'
import sleep from '@/utils/Sleep'
import VCardImageWithTextColumnas from './VCardImageWithTextColumnas.vue'

import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/swiper-bundle.css'
import SwiperCore, {
  Navigation,
  Pagination,
  Mousewheel,
  Keyboard
} from 'swiper'


export default /*#__PURE__*/_defineComponent({
  __name: 'TheBeneficios',
  props: {
    total: null
  },
  setup(__props: any) {

const props = __props as {
  total: number
};

SwiperCore.use([Navigation, Pagination, Mousewheel, Keyboard])



const isLoading = ref(true)
const { getBeneficios } = useSitio()

const beneficios = ref<
  {
    actividadId: number
    nombre: string
    bajada: string
    descripcion: string
    imagen: string
    titulo: string
  }[]
>([])

// Simular carga de datos
onMounted(async () => {
  isLoading.value = true
  await sleep(1)
  const data = await getBeneficios()
  beneficios.value = data
  isLoading.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.total, (index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "col-12 col-lg-4 mb-4"
                }, [
                  _createVNode(_unref(Skeletor), {
                    type: "rect",
                    width: "500px",
                    height: "280px",
                    class: "mb-5 rounded placeholder"
                  }),
                  _createVNode(_unref(Skeletor), {
                    type: "text",
                    width: "60%",
                    height: "20px",
                    class: "mb-5 small rounded"
                  }),
                  _createVNode(_unref(Skeletor), {
                    type: "text",
                    width: "100%",
                    height: "60px",
                    class: "mb-4 rounded"
                  }),
                  _createVNode(_unref(Skeletor), {
                    type: "button",
                    width: "150px",
                    height: "40px",
                    class: "rounded"
                  })
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (beneficios.value.length <= 2)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(beneficios.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-10 col-md-6 col-lg-5 col-xl-4",
                      key: item.actividadId
                    }, [
                      _createVNode(VCardImageWithTextColumnas, {
                        id: item.actividadId,
                        imagen: item.imagen ?? '',
                        titulo: item.titulo,
                        texto: item.descripcion
                      }, null, 8, ["id", "imagen", "titulo", "texto"])
                    ]))
                  }), 128))
                : (_openBlock(), _createBlock(_unref(Swiper), {
                    key: 1,
                    navigation: true,
                    pagination: true,
                    keyboard: true,
                    "preload-images": true,
                    "slides-per-view": 1,
                    "space-between": 30,
                    "centered-slides": true,
                    "center-insufficient-slides": true,
                    loop: true,
                    breakpoints: {
                '1600': {
                  slidesPerView: 3.1,
                  spaceBetween: 40
                },
                '1400': {
                  slidesPerView: 2.5,
                  spaceBetween: 40
                },
                '1200': {
                  slidesPerView: 1.9,
                  spaceBetween: 40
                },
                '992': {
                  slidesPerView: 1.6,
                  spaceBetween: 40
                },
                '768': {
                  slidesPerView: 1.25,
                  spaceBetween: 10
                },
                '576': {
                  slidesPerView: 1.25,
                  spaceBetween: 20
                },
                '0': {
                  slidesPerView: 0.9,
                  spaceBetween: 10
                }
              },
                    class: "bg-transparent p-5"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(beneficios.value, (item) => {
                        return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                          key: item.actividadId
                        }, {
                          default: _withCtx(() => [
                            _createVNode(VCardImageWithTextColumnas, {
                              id: item.actividadId,
                              imagen: item.imagen ?? '',
                              titulo: item.titulo,
                              texto: item.descripcion
                            }, null, 8, ["id", "imagen", "titulo", "texto"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["breakpoints"]))
            ])
          ]))
    ])
  ]))
}
}

})